module.exports = __webpack_public_path__ + "static/media/logoUtransfer.5ec7c52a.svg";